<template>
    <table class="table table-hover">
        <tbody>
            <ClientRow
                    :client="client"
                    v-for="client in clients"
                    v-bind:key="client.id"
                    @new-reservation-client-click="newReservationClientClick"
            ></ClientRow>
        </tbody>
    </table>
</template>

<script>
    import ClientRow from "./ClientRow";

    export default {
        name: "ClientTable",
        components: { ClientRow },
        props: {
            clients: {
                type: Array,
                required: true
            }
        },
        methods: {
            newReservationClientClick(clientId) {
                this.$emit('new-reservation-client-click', clientId)
            }
        }
    };
</script>
